import {Component, Inject, Vue} from "vue-property-decorator";
import {PageTitle} from "~/components/page-title";
import {icons} from "~/components/icon";
import {MainContainer} from "~/components/main-container";
import "./map-overlay-config.scss";
import {AppSettings} from "~/lib/app-settings";
import {Getter} from "vuex-class";
import {SettingsNavigationTabs, SettingsTab} from "~/modules/settings/components/navigation-tabs";
import {Loader} from "~/components/loader";
import {MapOverlays} from "~/modules/settings/components/map-overlays";
import {Metas} from "~/modules/settings/components/metas";

@Component
class SettingsView extends Vue {

  @Inject() appSettings: AppSettings;
  @Getter currentUser;

  private isLoading:boolean = false;
  private currentTab: SettingsTab = SettingsTab.MapOverlays;

  renderContent(){

    if (this.isLoading) {
      return <Loader/>;
    }

    switch(this.currentTab){
      case SettingsTab.MapOverlays :
        return <MapOverlays />;
      case SettingsTab.Metas:
        return <Metas />;
    }
  }

  render() {
    return (
      <MainContainer>
        <PageTitle icon={icons.allUsers} title="Paramètres"/>
        <SettingsNavigationTabs v-model={this.currentTab} />
        <div class="page-content">
          {this.renderContent()}
        </div>
      </MainContainer>
    )
  }
}

export {SettingsView}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-7e0d036e/settings-view.tsx" });